import { createSelector } from 'reselect'
import getSubtotalCartSelector from 'modules/cart/redux/selectors/get-subtotal'
import { shouldShowAOVLockProductVariantSelectorUtil } from 'modules/product-variant/redux/selectors/should-show-aov-lock/utils'
import getSelectedVariantSelect from 'modules/variant/redux/selectors/get-selected-variant'
import needsToBeRatedProductSelector from 'modules/product/redux/selectors/needs-to-be-rated'

/**
 * @param {ProductVariantCollection} productVariant
 * @returns {*}
 */
export const shouldShowAOVLockProductVariantSelector = ({
  productVariant
}) => createSelector(
  getSubtotalCartSelector(),
  getSelectedVariantSelect,
  needsToBeRatedProductSelector(productVariant?.product_id),
  (
    subtotal,
    selectedVariant,
    needsToBeRatedSample
  ) => {
    const selectedVariantToPass = selectedVariant?.product_id === productVariant?.product_id
      ? selectedVariant
      : null

    return shouldShowAOVLockProductVariantSelectorUtil({
      productVariant,
      subtotal,
      selectedVariant: selectedVariantToPass,
      needsToBeRatedSample
    })
  }
)
